import * as angular from "angular";
import {BarcodeScannerService} from "./services/barcode-scanner-service.service";
import {SplitService} from "./services/split-service.service";

angular
  .module('bringoz.admin.commons')
  .run(commonsRun);

/* @ngInject */
function commonsRun(splitService: SplitService, barcodeScannerService: BarcodeScannerService) {

// * initializeApp({
//     *   apiKey: "AIza....",                             // Auth / General Use
//     *   authDomain: "YOUR_APP.firebaseapp.com",         // Auth with popup/redirect
//     *   databaseURL: "https://YOUR_APP.firebaseio.com", // Realtime Database
//     *   storageBucket: "YOUR_APP.appspot.com",          // Storage
//     *   messagingSenderId: "123456789"                  // Cloud Messaging
//     * });


  // const firebaseConfig = {
  //   apiKey: "AIzaSyBz8reovE0CWRLTlQ3fJfQHZp6ho08CFhY",
  //   authDomain: "bringoz-testing.firebaseapp.com",
  //   databaseURL: "https://bringoz-testing.firebaseio.com",
  //   projectId: "bringoz-testing",
  //   storageBucket: "bringoz-testing.appspot.com",
  //   messagingSenderId: "857634918569",
  //   appId: "1:857634918569:web:4f1e0a41617c335ba819b8"
  // };

  // initializeApp(firebaseConfig, "US");
  // initializeApp(firebaseConfig, "EU");

  // Firebase apps are now initialized lazily, per-tenant, in FirebaseService.initFirebase()
  // once the /sites/{siteId}/channel response (which carries the tenant's databaseURL) is back.

  if (splitService.getBarcodeConfig().enable) {
    barcodeScannerService.startListening();
  }

}
